import ReportsFilters from './ReportsFilters';
import KpiCards from './KpiCards';
import ReportTable from './ReportTable';
import { formatCurrency, formatNumber } from './formatters';

const TourPerformance = ({
  data = [],
  filters,
  onFiltersChange,
  onApply,
  onExport,
  loading,
  exporting,
  tours = [],
  hosts = [],
  showHost = false,
  loadingMeta = false,
}) => {
  const totals = data.reduce(
    (acc, row) => {
      acc.gross += Number(row.grossRevenue || 0);
      acc.earnings += Number(row.hostEarnings || 0);
      acc.bookings += Number(row.totalBookings || 0);
      return acc;
    },
    { gross: 0, earnings: 0, bookings: 0 }
  );

  return (
    <div className="space-y-4">
      <ReportsFilters
        filters={filters}
        onChange={onFiltersChange}
        onApply={onApply}
        onExport={onExport}
        tours={tours}
        hosts={hosts}
        showHost={showHost}
        showTour
        showGroupBy={false}
        loadingMeta={loadingMeta}
        applying={loading}
        exporting={exporting}
      />

      <KpiCards
        items={[
          { label: 'Gross revenue', value: totals.gross, render: (v) => formatCurrency(v) },
          { label: 'Host earnings', value: totals.earnings, render: (v) => formatCurrency(v) },
          { label: 'Total bookings', value: totals.bookings, render: (v) => formatNumber(v) },
        ]}
      />

      <ReportTable
        loading={loading}
        columns={[
          { key: 'title', label: 'Tour' },
          { key: 'totalBookings', label: 'Bookings', render: formatNumber },
          { key: 'qtySold', label: 'Qty sold', render: formatNumber },
          { key: 'cancelledBookings', label: 'Cancelled', render: formatNumber },
          { key: 'grossRevenue', label: 'Gross', render: (v) => formatCurrency(v) },
          { key: 'hostEarnings', label: 'Host earnings', render: (v) => formatCurrency(v) },
          { key: 'platformFees', label: 'Fees', render: (v) => formatCurrency(v) },
        ]}
        rows={data}
        emptyText="No tour performance data."
      />
    </div>
  );
};

export default TourPerformance;
